import { useContext } from "react";
import { store } from "../App";

//const BASE_URL = "https://ims.akrais.com:8444";
const BASE_URL = "https://ims.akrais.com:8444";
const API_KEY = "IMSWEBAPI"
const API_REPORTS = "AKRAReportAPI"

async function FetchDataTypes(paramName, client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestType: `${paramName}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(`${BASE_URL}/${API_KEY}/api/dashboards`, requestOptions);
}

async function FetchDataTypess(paramName, client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestType: `${paramName}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(`${BASE_URL}/${API_KEY}/api/dashboards`, requestOptions);
}

async function FetchOpenTradeOrders(startTIme, closeTIme, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    //RequestType: `${paramName}`,
    FromEnteredTime: `${startTIme}`,
    ToEnteredTime: `${closeTIme}`,
    //Status:  `${status}`,
    userID: 1,
    clientID: 1,
  });

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/tdameritrade/orders?accountId=275353556&maxResults=100&fromEnteredTime=${startTIme}&toEnteredTime=${closeTIme}&status=WORKING`,
    requestOptions
  );
}

async function FetchSecurityMaster(paramName, client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestParamType: `${paramName}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/data`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

async function postTrades(paramName, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestType: `${paramName}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/tdameritrade/275353556/orders`,
    requestOptions
  );
}

async function postNewTrades(paramName, token) {
  var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/tdameritrade/275353556/orders`,
    requestOptions
  );
}

async function MetaDataList(clientID, token) {
  var myHeaders = new Headers();

  myHeaders.append("ClientID", `${clientID}`);
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };

  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata`,
    requestOptions
  );
  const data = await response.json();
  return data;
}


async function GetMetaDataByID(id, clientID, token) {
  
  var myHeaders = new Headers();

  myHeaders.append("ClientID", `${clientID}`);
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };

  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${id}`,
    requestOptions
  );
}

async function MetaDataDetails(id, clientID, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", `${clientID}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${id}/parameters`,
    requestOptions
  );
}

async function MetaDataDetailsExecute(selectedName, selectedDate, token) {
  var raw = JSON.stringify({
    date: `${selectedDate}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${selectedName}/execute`,
    requestOptions
  );
}

async function MetaDataDetailsDownload(selectedName, getTaskDownload, token) {
  var raw = JSON.stringify({
    Type: `${getTaskDownload}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
    responseType: "blob", // Important
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${selectedName}/download`,
    requestOptions
  );
}

async function GetForgotPassword(email) {
  var raw = JSON.stringify({
    email: `${email}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/forgotpassword`,
    requestOptions
  ).then((response) => response);
}

async function GetResetPassword(email, createPassword, confirmPassword, token) {
  var raw = JSON.stringify({
    password: `${createPassword}`,
    confirmPassword: `${confirmPassword}`,
    email: `${email}`,
    token: `${token}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/resetpassword`,
    requestOptions
  );
}

async function GetChangePassword(
  currentPassword,
  newPassword,
  confirmPassword,
  token
) {
  var raw = JSON.stringify({
    currentPassword: `${currentPassword}`,
    password: `${newPassword}`,
    confirmPassword: `${confirmPassword}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/changepassword`,
    requestOptions
  );
}

async function CreateUser(email, firstName, lastName, userRols, accountIDs, client, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    email: email,
    firstName: firstName,
    lastName: lastName,
    RoleId: userRols,
    AccountIds: accountIDs
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/users/register`,
    requestOptions
  );
}

async function UpdateUser(id, firstName, lastName, phoneNumber, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    firstName: `${firstName}`,
    lastName: `${lastName}`,
    phoneNumber: `${phoneNumber}`,
  });

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/users/${id}`,
    requestOptions
  );
}

async function GetUsersList(ClientID, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", `${ClientID}`);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/users`,
    requestOptions
  );
}

async function getUserTestList(ClientID, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("ClientID", `${ClientID}`);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/users`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

async function deleteUser(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${id}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/users/${id}`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

async function activateUser(id, status, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/users/${id}/status?enable=${status}`,
    requestOptions
  );
  const data = await response;
  return data;
}

async function getTradeList(startTIme, closeTIme, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/tdameritrade/orders?accountId=275353556&maxResults=100&fromEnteredTime=${startTIme}&toEnteredTime=${closeTIme}`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

async function getOpenTradeOrdersList(startTIme, closeTIme, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/tdameritrade/orders?accountId=275353556&maxResults=100&fromEnteredTime=${startTIme}&toEnteredTime=${closeTIme}&status=WORKING`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

async function updateLockStatus(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    //body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/users/${id}/unlock`,
    requestOptions
  );
  const data = await response;
  return data;
}

async function GetApiData(parameterid, inputdatasourcename, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestParamType: `${parameterid}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/parameters/${parameterid}/inputdatasource/${inputdatasourcename}/execute`,
    requestOptions
  );
}

async function GetDyanmicFormApiData(parameterid, data, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Accept", "application/json");

  // var raw = JSON.stringify({
  //   RequestParamType: `${data}`,

  // });

  var requestOptions = {
    method: "post",
    headers: myHeaders,
    body: JSON.stringify(data),
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${parameterid}/execute`,
    requestOptions
  );
}

// create metadata and parameters

async function CreateMetaData(data, token) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata`,
    requestOptions
  );
}

async function CreateNewParamenter(metaID, data, token) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${metaID}/bulkparameters`,
    requestOptions
  );
}

async function DeleteNewMeta(metaID, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${metaID}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${metaID}`,
    requestOptions
  );
  const data = await response;
  return data;
}
//${BASE_URL}/${API_KEY}/api/metadata/6982dd6e-a482-4fb5-b103-2028e454a6d8/parameters

async function getParameterDetails(inputdataSource, clientID, token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${inputdataSource}/parameters`,
    requestOptions
  );
}

async function getMetaDateDetails(inputdataSource, token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${inputdataSource}`,
    requestOptions
  );
}

// reports download progress

async function ReportsDownload(newPayload, selctedID, token) {
  var raw = JSON.stringify({
    Type: `${newPayload}`,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: raw,
    redirect: "follow",
    responseType: "blob", // Important
  };
  return await fetch(
    `${BASE_URL}/AKRAReportAPI/api/ims/reports/${selctedID}/download`,
    requestOptions
  );
}

async function getTransactionList(Transactions, client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestParamType: `${Transactions}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/data`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

async function getApiDashBoardData(RequestType, client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestType: `${RequestType}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/dashboards`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

async function UpdateTransactions(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/transactions/${id}`,
    requestOptions
  );
}

async function deleteTransactions(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${id}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/pendingtransaction/${id}`,
    requestOptions
  );
  const data = await response;
  return data;
}

async function AddFundData(payload, token) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/funds`,
    requestOptions
  );
}

async function getFundById(id, token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/funds/${id}`,
    requestOptions
  );
}

async function updateFundData(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/funds/${id}`,
    requestOptions
  );
}

async function deleteFundData(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${id}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/funds/${id}`,
    requestOptions
  );
  return response;
}

async function AddParticipants(payload, token) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/participants`,
    requestOptions
  );
}
async function updateParticipantsData(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/participants/${id}`,
    requestOptions
  );
}

async function updateParticipant(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/participants/${id}`,
    requestOptions
  );
}

async function deleteParticipant(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${id}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/participants/${id}`,
    requestOptions
  );
  return response;
}

async function ClientsList(token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/clients`,
    requestOptions
  );
}

async function ExportParameters(payload, metaDataId, token) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${metaDataId}/bulkexportparameters`,
    requestOptions
  );
}
async function GetExportParameters(id, clientID, token) {
 
  var myHeaders = new Headers();
  myHeaders.append("ClientID", `${clientID}`);
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${id}/exportparameters`,
    requestOptions
  );
}

async function updateMetaData(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/metadata/${id}`,
    requestOptions
  );
}
async function updateParameterData(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/parameters/${id}`,
    requestOptions
  );
}
async function updateExportParameterData(id, payload, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(payload);

  var requestOptions = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/exportparameters/${id}`,
    requestOptions
  );
}

// Delete a parameter
async function deleteParameter(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${id}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/parameters/${id}`,
    requestOptions
  );
  return response;
}

// Delete Export Parameters

async function deleteExportParameter(id, token) {
  var myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    id: `${id}`,
  });

  var requestOptions = {
    method: "DELETE",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/exportparameters/${id}`,
    requestOptions
  );
  return response;
}

async function lastFundPriceDate(paramName, client, selectFundId, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestParamType: `${paramName}`,
    Filter: `${selectFundId}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/data`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

// add allocations

async function addAllocations(payload, clientID, id, token) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ClientID: `${clientID}`,
    },
    body: JSON.stringify(payload),
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/funds/${id}/allocations`,
    requestOptions
  );
}

// async function adminStatementsList(payload,token) {
//   var requestOptions = {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//     body: JSON.stringify(payload),
//     redirect: "follow",
//   };

//   const response = await fetch(`${BASE_URL}/${API_KEY}/api/adminstatements/search`, requestOptions);
//   const data = await response.json();
//   return data;
// }

async function adminStatementsList(payload,client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(payload),
    redirect: "follow",
  };

  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/adminstatements/search`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

async function statementsList(payload, client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(payload),
    redirect: "follow",
  };

  const response = await fetch(
    `${BASE_URL}/${API_KEY}/api/statements/search`,
    requestOptions
  );
  const data = await response.json();
  return data;
}

async function getRoles(token) {
  //var raw = JSON.stringify(paramName);

  var requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    //body: raw,
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/roles`,
    requestOptions
  );
}
async function fetchSPNames(token, client, RequestParamType, Filter) {
  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ClientID: client
    },
    body: JSON.stringify(
      {  RequestParamType: `${RequestParamType}`,
        Filter: `${Filter}`,}
      
    ), // Include your payload here
    redirect: "follow",
  };
  return await fetch(
    `${BASE_URL}/${API_KEY}/api/data`,
    requestOptions
  );
}

async function fetchDashboardTitles(paramName, client, token) {
  var myHeaders = new Headers();

  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("ClientID", client);
  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    RequestType: `${paramName}`,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  return await fetch(`${BASE_URL}/${API_KEY}/api/dashboards`, requestOptions);
}

export {
  BASE_URL,
  API_KEY,
  API_REPORTS,
  FetchDataTypes,
  FetchOpenTradeOrders,
  FetchSecurityMaster,
  postTrades,
  postNewTrades,
  MetaDataList,
  MetaDataDetails,
  MetaDataDetailsExecute,
  MetaDataDetailsDownload,
  GetForgotPassword,
  GetResetPassword,
  GetChangePassword,
  CreateUser,
  GetUsersList,
  UpdateUser,
  getUserTestList,
  deleteUser,
  activateUser,
  getOpenTradeOrdersList,
  getTradeList,
  updateLockStatus,
  GetApiData,
  GetDyanmicFormApiData,
  CreateMetaData,
  CreateNewParamenter,
  DeleteNewMeta,
  getParameterDetails,
  getMetaDateDetails,
  ReportsDownload,
  getTransactionList,
  getApiDashBoardData,
  UpdateTransactions,
  deleteTransactions,
  AddFundData,
  AddParticipants,
  ClientsList,
  FetchDataTypess,
  ExportParameters,
  GetMetaDataByID,
  GetExportParameters,
  updateMetaData,
  updateParameterData,
  updateExportParameterData,
  deleteParameter,
  deleteExportParameter,
  deleteFundData,
  getFundById,
  updateFundData,
  deleteParticipant,
  updateParticipant,
  updateParticipantsData,
  lastFundPriceDate,
  addAllocations,
  adminStatementsList,
  statementsList,
  getRoles,
  fetchSPNames,
  fetchDashboardTitles
};
